import { Checkbox, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';

class Transcendencia extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            transcendencia: computed,
            toggleIndicarTranscendencia: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get transcendencia() {
        return this.registro.transcendencia;
    }

    toggleIndicarTranscendencia = async () => {
        let result = await this.processoService.marcarTranscendencia(
            this.sessaoStore.idSessaoSelecionada,
            this.registro
        );
        runInAction(() => {
            if (result !== this.registro.transcendencia) {
                this.registro.transcendencia = result;
            } else {
                this.mensagemStore.abrirMensagemErro('Ocorreu um erro ao alterar a indicação de transcendência.');
            }
        });
    };

    render() {
        if (!this.isComponenteHabilitado('Transcendencia')) {
            return null;
        }
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                    size="small"
                    checked={this.registro.transcendencia}
                    onChange={this.toggleIndicarTranscendencia}
                    style={{ padding: '2px 10px' }}
                />
                <Typography
                    style={{
                        color: this.transcendencia ? red[800] : '#01579b',
                        fontWeight: 'bold',
                        fontSize: '0.95rem'
                    }}
                >
                    {'Transcendência reconhecida'}
                </Typography>
            </div>
        );
    }
}

export default inject('stores')(observer(Transcendencia));
